/**
 * Helper para construir query strings para requisições
 * @param {Object} params - Parâmetros da query
 * @param {number} params.page - Número da página (0-indexed)
 * @param {number} params.size - Tamanho da página
 * @param {string} params.sort - Campo e direção de ordenação (ex: "field,asc")
 * @param {Object} params.filters - Objeto com filtros opcionais
 * @returns {string} Query string formatada
 */
export function buildQueryString({ page = 0, size = 5, sort, filters = {} }) {
    const params = new URLSearchParams();
    
    params.append('page', page);
    params.append('size', size);
    
    if (sort) {
        params.append('sort', sort);
    }
    
    // Adiciona filtros opcionais
    Object.entries(filters).forEach(([key, value]) => {
        // Inclui valores booleanos (incluindo false) e outros valores válidos
        if (value !== undefined && value !== null && value !== '') {
            // Converte boolean para string para a query
            const paramValue = typeof value === 'boolean' ? String(value) : value;
            params.append(key, paramValue);
        }
    });
    
    return params.toString();
}
